import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

const MAX_LAYOUT_FRAMES = 48;

@Directive({
  selector: '[appScrollToBottom]',
  standalone: true,
})
export class ScrollToBottomDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input('appScrollToBottom') trigger: unknown;

  private rafId?: number;
  private resizeObserver?: ResizeObserver;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.observeResize();
    this.scheduleScroll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trigger'] && !changes['trigger'].firstChange) {
      this.scheduleScroll();
    }
  }

  ngOnDestroy(): void {
    this.cancelScroll();
    this.resizeObserver?.disconnect();
  }

  private observeResize(): void {
    if (typeof ResizeObserver === 'undefined') return;

    this.resizeObserver = new ResizeObserver(() => this.scheduleScroll());
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  private cancelScroll(): void {
    if (this.rafId == null) return;
    cancelAnimationFrame(this.rafId);
    this.rafId = undefined;
  }

  private scheduleScroll(): void {
    this.cancelScroll();
    let lastHeight = -1;
    let attempts = 0;
    const run = (): void => {
      this.rafId = undefined;
      const el = this.elementRef.nativeElement;
      el.scrollTop = el.scrollHeight;
      if (el.scrollHeight !== lastHeight && attempts++ < MAX_LAYOUT_FRAMES) {
        lastHeight = el.scrollHeight;
        this.rafId = requestAnimationFrame(run);
      }
    };
    this.rafId = requestAnimationFrame(run);
  }
}
